var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { RouteFiller } from "../helpers/Helpers";
import { CollaborationServiceSetup } from "../Setup";
export var IdToNameController = {
    /*****************************************************************************************************
        * Is using route "api/idToName" and http method "POST" to call the back-end.
    
        * @param {IdToNameSearch} search
        * @returns {IdToName[]}
    ******************************************************************************************************/
    Search: function (data, onSuccess, onError, onProgress, mutex) {
        var fd = new FormData();
        fd.append("search", JSON.stringify(data.search));
        CollaborationServiceSetup.client.call({
            uri: RouteFiller("api/idToName", __assign({}, data)),
            method: "POST",
            onSuccess: onSuccess,
            onError: onError,
            onProgress: onProgress,
            mutex: mutex,
            data: fd,
        });
    },
};
/*
$PrintDebugInfo
*/ 
//# sourceMappingURL=IdToNameController.js.map